import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import Demo from './demo/app';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<Demo />);
